
import { Component, Prop, Vue } from "vue-property-decorator";
import { ValidationProvider } from "vee-validate";

@Component({ components: { ValidationProvider } })
export default class BookingContactFields extends Vue {
  @Prop() contactPerson!: string | null;
  @Prop() contactNumber!: string | null;
}
